<template>
  <div class="table-responsive" style="overflow-y: auto">
    <table class="table table-hover table-sm">
      <thead class="table-light position-sticky top-0">
        <tr>
          <th
            v-for="field in fields"
            :key="field.key"
            :style="{ cursor: field.sortable ? 'pointer' : 'default' }"
            @click="field.sortable && toggleSort(field.key)"
          >
            {{ field.label }}
            <span v-if="field.sortable">
              <font-awesome-icon
                v-if="sortBy === field.key"
                :icon="sortDesc ? 'arrow-up-z-a' : 'arrow-up-a-z'"
                class="ms-1"
                :style="{ color: '#000' }"
              />
              <font-awesome-icon v-else icon="arrow-up-a-z" class="ms-1" style="color: #999" />
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="isBusy">
          <td :colspan="fields.length" class="text-center">Loading...</td>
        </tr>
        <tr
          v-for="(item, index) in sortedItems"
          :key="item.id || index"
          @click="selectRow(item)"
          :class="{ 'row-selected-grey': selectedRow?.id === item.id }"
          style="cursor: pointer"
        >
          <td
            v-for="field in fields"
            :key="field.key"
            :style="{ backgroundColor: selectedRow?.id === item.id ? '#aeaeae' : '#fff' }"
          >
            <template v-if="linkFields[field.key]">
              <router-link :to="linkFields[field.key] + item.id" @click.stop class="emailCell">
                {{ item[field.key] }}
              </router-link>
            </template>
            <template v-else>
              {{ field.key.includes(".") ? item[field.key.split(".")[0]]?.[field.key.split(".")[1]] : item[field.key] }}
            </template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "DataTable",
  props: {
    items: {
      type: Array,
      required: true
    },
    fields: {
      type: Array,
      required: true
    },
    isBusy: {
      type: Boolean,
      default: false
    },
    sortBy: {
      type: String
    },
    sortDesc: {
      type: Boolean,
      default: false
    },
    linkFields: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:sortDesc", "sort-changed", "row-selected", "update:sortBy"],
  data() {
    return {
      selectedRow: null
    };
  },
  mounted() {
    document.addEventListener("click", this.clearSelection);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.clearSelection);
  },
  computed: {
    sortedItems() {
      if (!this.sortBy) return this.items;

      const sorted = [...this.items];
      sorted.sort((a, b) => {
        const valA = a[this.sortBy];
        const valB = b[this.sortBy];
        if (valA < valB) return this.sortDesc ? 1 : -1;
        if (valA > valB) return this.sortDesc ? -1 : 1;
        return 0;
      });
      return sorted;
    }
  },
  methods: {
    toggleSort(fieldKey) {
      const isSame = fieldKey === this.sortBy;
      const newSortDesc = isSame ? !this.sortDesc : false;
      this.$emit("update:sortDesc", newSortDesc);
      this.$emit("sort-changed", { sortBy: fieldKey, sortDesc: newSortDesc });
      this.$emit("update:sortBy", fieldKey);
    },
    selectRow(row) {
      this.selectedRow = row;
      this.$emit("row-selected", row);
    },
    clearSelection(event) {
      if (!this.$el.contains(event.target)) {
        this.selectedRow = null;
      }
    }
  }
};
</script>
<style scoped>
.table-responsive {
  background-color: #ffffff;
  padding: 1rem;
  font-family: Arial, sans-serif;
  font-size: 16px;
  overflow-x: auto;
}

.table {
  width: 100%;
  border-collapse: collapse;
  background-color: #ffffff;
}

.table th,
.table td {
  padding: 12px;
  text-align: left;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  border-left: none;
  border-right: none;
  background-color: #ffffff;
}

.table thead th {
  font-weight: bold;
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: #ffffff;
}

.table-hover tbody tr:hover {
  background-color: #f9f9f9;
}

.table-primary {
  background-color: #e6f2ff !important;
  color: #0054a6;
}
.emailCell {
  text-decoration: none;
  color: #0054a6;
}
</style>
